import { createAction } from "@reduxjs/toolkit";

// add actions related to the group
export const auth = createAction("Auth_USER");
export const setUserAccess = createAction("USER_ACCESS");
export const GoogleAuthAction = createAction(
  "GOOGLE_Auth",
  (payload, callback) => ({
    payload: { data: payload, callback },
  })
);

//export const saveUser = createAction("SAVE_USER");
export const LogoutAction = createAction("LOGOUT");
